export enum ClientSignatureType {
    HANDWRITTEN = 'handwritten_signature',
    IN_PERSON_ELECTRONIC = 'in_person_electronic_signature',
    REMOTE_ELECTRONIC = 'remote_electronic_signature',
}
